import { supabase } from "@/lib/api";

export const analyticsService = {
  async getSummary() {
    const { data: roles } = await supabase.from('projects').select('*');
    const { data: candidates } = await supabase.from('candidates').select('*');
    const { data: vendors } = await supabase.from('vendors').select('*');

    return {
      roles: {
        total: roles?.length || 0,
        active: roles?.filter(p => p.status === 'active').length || 0,
        completed: roles?.filter(p => p.status === 'completed').length || 0,
        onHold: roles?.filter(p => p.status === 'on-hold').length || 0,
      },
      candidates: {
        total: candidates?.length || 0,
        hired: candidates?.filter(c => c.status === 'hired').length || 0,
        new: candidates?.filter(c => c.status === 'new').length || 0,
        screening: candidates?.filter(c => c.status === 'screening').length || 0,
        interview: candidates?.filter(c => c.status === 'interview').length || 0,
        rejected: candidates?.filter(c => c.status === 'rejected').length || 0,
      },
      vendors: {
        total: vendors?.length || 0,
        active: vendors?.filter(v => v.status === 'active').length || 0,
      }
    };
  },

  async getMonthlyStats() {
    const { data: roles } = await supabase.from('projects').select('*');
    const { data: candidates } = await supabase.from('candidates').select('*');
    const { data: vendors } = await supabase.from('vendors').select('*');

    return {
      roles: this.processMonthlyData(roles || []),
      candidates: this.processMonthlyData(candidates || []),
      vendors: this.processMonthlyData(vendors || [])
    };
  },

  async getVendorPerformance() {
    const { data: vendors } = await supabase.from('vendors').select('*');
    const { data: roles } = await supabase.from('projects').select('*');

    return vendors?.map(vendor => {
      const vendorRoles = roles?.filter(p => p.vendorId === vendor.id) || [];
      return {
        vendorId: vendor.id,
        vendorName: vendor.name,
        totalRoles: vendorRoles.length,
        completedRoles: vendorRoles.filter(p => p.status === 'completed').length,
        activeRoles: vendorRoles.filter(p => p.status === 'active').length,
      };
    }) || [];
  },

  processMonthlyData(data: any[]) {
    const monthlyData = new Map();
    data.forEach(item => {
      const date = new Date(item.created_at);
      const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      
      if (!monthlyData.has(monthKey)) {
        monthlyData.set(monthKey, { month: monthKey, count: 0 });
      }
      monthlyData.get(monthKey).count++;
    });
    return Array.from(monthlyData.values());
  }
};
